import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0075',
    ecrans: ['00-2']
});
